import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

import Typography from '@/components_new/Typography.vue'
import { APIGameType, GameCategoriesInfoType } from '@/types'

interface GameStickyBannerProps {
    game: APIGameType
    categories?: GameCategoriesInfoType
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StickyGameBanner',
  props: {
    game: {},
    categories: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.sticky_banner)
  }, [
    _createElementVNode("img", {
      src: props.game.icon,
      alt: props.game.title,
      class: _normalizeClass(_ctx.$style.icon)
    }, null, 10, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.texts)
    }, [
      _createVNode(Typography, {
        type: "label",
        size: "m",
        accent: "",
        class: _normalizeClass(_ctx.$style.title)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.game.title), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Typography, {
        type: "label",
        size: "xs",
        class: _normalizeClass(_ctx.$style.category)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.categories?.categoriesInfo?.[0]?.title || '-'), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ], 2)
  ], 2))
}
}

})